<template>
    <div>
        <div class="completion-rate">
            <div style="position:absolute;top: 11px"> Completion Rate:</div>
            <transition name="fade" mode="out-in">
                <div v-if="!completionRateLoaded || runningfetchCompletionRateCount !== 0" :key="0"
                     class="completion-rate-not-loaded">
                    <div class="loaderContainer" style="width:23px">
                        <svg class="spinner" viewBox="0 0 50 50" style="width:23px; height:23px">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
                <div v-else :key="1">
                    <div class="detailInfo">
                        <div class="content">
                            <span style="margin-top:1px;"> {{this.completionRate}} %</span>
                            <div class="bubble_container">
                                <InfoBubble v-if="dateString !== ''" :is-filled="false" :value="dateString"
                                            :disabled="true" color="purple"></InfoBubble>
                                <InfoBubble v-if="volumeString !== ''" :is-filled="false" :value="volumeString"
                                            :disabled="true" color="purple"></InfoBubble>
                            </div>
                        </div>
                        <span v-if="editable" @click="showSettings = true" class="settingsIcon">
                            <unicon class="icon" name="setting" fill="#394956"></unicon>
                        </span>
                    </div>
                    <div>
                        <progressbar class="progress" :progress="completionRate"></progressbar>
                    </div>
                </div>
            </transition>
        </div>
        <Dialog :show="showSettings" :has-backdrop="true" :show-close-button="true" @close="showSettings = false"
        >
            <div class="content">
                <h4>Completion Rate Einstellungen</h4>
                <div class="content">
                    <div class="section">
                        <div>Bitte den Zeitraum auswählen</div>
                        <div class="cr-item first">
                            <date-selection-combo :max="false" :global="false" :initial-range="goalRange"
                                                  id="crs-datepicker" class="datePicker"
                                                  @dateChange="updateCompletionRateRange"></date-selection-combo>
                        </div>
                    </div>
                    <div class="section">
                        <div>Bitte den Umsatz angeben</div>
                        <div class="cr-item">
                            <CurrencyInput @input="updateVolume" @enter="save" v-model="vol"
                                           :options="{ currency: 'EUR'}"/>
                            <!--<NumberInput v-model="vol" :min="0" ></NumberInput>-->
                            <div v-if="volumeString !== ''" class="volBubble">
                                <InfoBubble @bubbleDeleted="initial = 0; vol = 0" :value="volumeString"
                                            color="blue"></InfoBubble>
                            </div>
                        </div>
                        <AdaButton @click="save" title="Bestätigen"></AdaButton>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "../../../components/dialogs/Dialog";
    import DateSelectionCombo from "../../../components/datePicker/DateSelectionCombo";
    import Progressbar from "./Progressbar";
    import Utils from "../../../scripts/utils";
    import moment from 'moment';
    // import NumberInput from "../../../components/inputs/NumberInput";
    import InfoBubble from "../../../components/inputs/InfoBubble";
    import CurrencyInput from "../../../components/inputs/CurrencyInput";
    import AdaButton from "../../../components/buttons/AdaButton";

    export default {
        name: "CompletionRate",
        components: {AdaButton, CurrencyInput, InfoBubble, Dialog, Progressbar, DateSelectionCombo},
        props: {
            editable: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                showSettings: false,
                range: {
                    start: null,
                    end: null
                },
                vol: 0,
                initial: null,
                completionRateLoaded: false,
                runningfetchCompletionRateCount: 0
            }
        },
        mounted() {
            if (this.preset) {
                this.fetchCompletionRate();
                if (this.volume !== 0) {
                    this.initial = this.volume;
                }
                this.completionRateLoaded = true;
            }

        },
        computed: {
            colWidth() {
                return Utils.calcColWidth();
            },
            vuexState() {
                return this.$store.state.presets;
            },
            preset() {
                return this.vuexState.currentPreset;
            },
            volume() {
                return this.preset && parseInt(this.preset.goal_quantity) ? this.preset.goal_quantity : 0;
            },
            startDate() {
                return this.preset && this.preset.goal_quantity_start ? this.preset.goal_quantity_start : '';
            },
            endDate() {
                return this.preset && this.preset.goal_quantity_end ? this.preset.goal_quantity_end : '';
            },
            completionRate() {
                return this.vuexState.completionRate;
            },
            detailInfo() {
                let ret = "(" + this.dateString + ', ' + this.volumeString + ")";
                return this.volumeString !== '' && this.dateString !== '' ? ret : '';
            },
            volumeString() {
                return this.volume !== 0 && this.volume !== '0' ? this.formatNumber(this.volume) + ' €' : '';
            },
            dateString() {
                return this.startDate !== '' && this.endDate !== '' ? moment(this.startDate, 'YYYY-MM-DD').format('DD.MM.YY') + ' - ' + moment(this.endDate, 'YYYY-MM-DD').format('DD.MM.YY') : '';
            },
            goalRange() {
                return this.startDate !== '' && this.endDate !== '' ? {start: this.startDate, end: this.endDate} : {};
            }
        },
        methods: {
            updateCompletionRateRange(range) {
                if (this.completionRateLoaded) {
                    this.$store.commit('presets/setChangesMade', true);
                }
                this.range = range;
            },
            save() {
                if (!this.range.start || !this.range.end) {
                    this.range = this.goalRange;
                }

                let vol = (this.vol && (!isNaN(this.vol))) || this.vol === 0 ? this.vol : (this.volume && this.volume !== 0 ? this.volume : (this.initial && this.initial !== 0 ? this.initial : 0));
                let ret = {
                    range: this.range,
                    volume: vol
                };
                this.$store.commit('presets/updateGoalQuantity', ret);
                this.showSettings = false;
                this.completionRateLoaded = false;
                this.fetchCompletionRate();
                this.completionRateLoaded = true;
            },
            updateVolume(vol) {
                if (vol !== '' && vol !== null) {
                    if (typeof vol === 'string') {
                        vol = vol.replace("€", "");
                        vol = vol.replaceAll(".", "");
                        vol = vol.replaceAll(",", ".");
                        vol = parseFloat(vol);
                    }

                    console.log('update vol');
                    if (this.completionRateLoaded) {
                        this.$store.commit('presets/setChangesMade', true);
                    }
                    this.vol = vol;
                }

            },
            async fetchCompletionRate() {
                this.runningfetchCompletionRateCount++;
                await this.$store.dispatch('presets/fetchCompletionRate', {
                    preset_id: this.presetId,
                    dates: this.dates
                });
                this.runningfetchCompletionRateCount--;
            },
            formatNumber(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
        },
        watch: {
            volume() {
                this.vol = this.volume;
            },
            preset() {
                if (this.preset) {
                    this.completionRateLoaded = false;
                    this.fetchCompletionRate();
                    if (this.volume !== 0) {
                        this.initial = this.volume;
                    }
                    this.completionRateLoaded = true;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .settings {
        margin-right: 15px;
        float: left;
    }

    .box {
        display: inline-block;
        padding: 1rem;
        //  min-height: 100px;
    }


    .btn {
        display: inline-flex;
        align-items: center;
        background-color: #394956;
        border-radius: 4px;
        padding: 8px 10px;
        float: right;
        color: #fff;
        cursor: pointer;
    }

    .icon {
        margin-left: .3rem;
    }

    .settings-content {
        display: inline-flex;
        align-items: center;
    }

    .icon-edit {
        cursor: pointer;
    }

    #volume {
        margin-bottom: 0;
    }

    .content {
        display: flex;
        flex-flow: column;
        width: 100%;

        .section {
            &:not(:last-child) {
                margin-bottom: 30px;
            }

          :deep( .cr-item) {
                margin-top: 20px;
            }
        }

      :deep( .router) {
            margin-top: 30px;
        }

    }

    .completion-rate {
        font-weight: bold;
        background: #fff;
        padding: 10px;
        min-height: 42px;
        position: relative;
    }

    .detailInfo {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin-left: 137px;

        .content {
            display: flex;
            flex-flow: row;

            .bubble_container {
                margin-left: 20px;
                font-weight: 500;

              :deep( .infoBubble) {
                    font-size: 14px;

                    &:not(:last-child) {
                        margin-right: 15px;
                    }
                }
            }
        }
    }

    .settingsIcon {
        float: right;
        cursor: pointer;
        position: relative;
        top: -2px;
    }

    .completion-rate-not-loaded {
        display: flex;
        flex-flow: row;
        margin-left: 125px;
    }

    .loaderContainer {
        margin-left: 5px;
        position: relative;
        top: -2px;

        .spinner {
            animation: rotate 2s linear infinite;
            z-index: 2;
            position: absolute;

            top: 50%;
            left: 50%;


            & .path {
                stroke: #394956;
                stroke-linecap: round;
                animation: dash 1.5s ease-in-out infinite;
            }

        }
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }

    .volBubble {
        margin-left: 2rem;
        display: inline-block;
    }

    .cr-item {
        margin-top: 2rem;
        display: block;
        width: 100%;
    }

    h5 {
        margin-left: 0;
    }
</style>